import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import api from "@/lib/api";

const I18nContext = createContext(null);
const VALID = ["it", "en", "ro", "de", "fr"];

export function I18nProvider({ children }) {
  const stored = localStorage.getItem("rt_locale");
  const [locale, setLocale] = useState(stored || "it");

  // First visit (no manual choice yet): auto-detect language from IP country.
  useEffect(() => {
    if (stored) return;
    let active = true;
    api.get("/public/geo-locale")
      .then(({ data }) => {
        if (active && data?.locale && VALID.includes(data.locale) && !localStorage.getItem("rt_locale")) {
          setLocale(data.locale);
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  // Manual selection persists so it always overrides auto-detection on next visits.
  const choose = (l) => {
    localStorage.setItem("rt_locale", l);
    setLocale(l);
  };

  const t = (key) => {
    const dict = translations[locale] || {};
    return dict[key] || translations.en[key] || key;
  };

  return (
    <I18nContext.Provider value={{ locale, setLocale: choose, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
